import { getMySubscriptionStatusApi as generatedGetMySubscriptionStatusApi } from '../generated/billing/getMySubscriptionStatus';

const getMySubscriptionStatusApi = generatedGetMySubscriptionStatusApi.enhanceEndpoints({
  endpoints: {
    getMySubscriptionStatus: {
      providesTags: [{ id: 'ME', type: 'Subscription' }],
    },
  },
});

export const { useGetMySubscriptionStatusQuery } = getMySubscriptionStatusApi;
export { getMySubscriptionStatusApi };
